const STORAGE_KEY = 'adminPartnerReportsSelectedPartnerId'

function readStoredPartnerId() {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  // PartnerSelect.vue آیدی‌ها رو به‌صورت عدد (item-value) نگه می‌داره؛ localStorage همیشه
  // رشته برمی‌گردونه -- بدون این تبدیل، v-autocomplete مقدار بازیابی‌شده رو تشخیص نمی‌ده
  // و دراپ‌داون خالی نشون داده می‌شه، حتی اگه partnerId زیرِ کاپوت درست باشه.
  const num = Number(raw)
  return Number.isNaN(num) ? raw : num
}

export default {
  data() {
    return {
      // انتخاب شریک بین صفحه‌های مختلف گزارش‌گیری (که هرکدوم جدا لود میشن) حفظ بشه
      partnerId: readStoredPartnerId(),
    }
  },

  watch: {
    partnerId(value) {
      if (value) localStorage.setItem(STORAGE_KEY, value)
      else localStorage.removeItem(STORAGE_KEY)
    },
  },
}
